import { Component, AfterViewInit, OnInit, Inject, ViewChild, ElementRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { GestionVendedorService } from "src/app/servicios/gestion-vendedor.service";
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { GestionVendedorCarteraService } from "src/app/servicios/gestion-vendedor-cartera.service";

@Component({
  selector: 'app-dialog-detalle-cartera',
  templateUrl: './dialog-detalle-cartera.component.html',
  styleUrls: ['./dialog-detalle-cartera.component.css']
})
export class DialogDetalleCarteraComponent implements OnInit {
  @ViewChild('mapContainer') gmap: ElementRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  map: google.maps.Map;
  //lat = 4.534791811470397;
  //lng = -75.6730720611766;
  coordinates:any;
  /*mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 16,
  };*/

  marker:any;

  dataCliente:any;
  dataModified=false;


  dtTrigger = new Subject();

  haveData = false;
  timeRunning = 0;

  idEncabezado: any;
  detallePedido = [];
  loadingData = false;
  totalPedido=0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialog,
    private servicioGestionVendedor: GestionVendedorCarteraService
  ) {
    this.idEncabezado = dataDialog.documento;
    this.dataCliente = dataDialog;

    //console.log(this.dataCliente);
    this.loadingData = true;
    this.servicioGestionVendedor
      .getDetalleRecaudo(this.idEncabezado)
      .subscribe(result => {


        this.detallePedido = result;
        if(this.detallePedido.length>0){
          this.haveData=true;
        }

        this.detallePedido.forEach(element=>{
          this.totalPedido +=element.montoRCMP;
        });

        this.dtTrigger.next();
        //console.log(this.detallePedido);
        this.loadingData = false;
      });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.mapInitializer();
  }

  mapInitializer() {
    this.coordinates=new google.maps.LatLng(this.dataCliente.Latitud, this.dataCliente.Longitud);
    this.marker=new google.maps.Marker({
      position: this.coordinates,
      map: this.map,
    });
    this.map = new google.maps.Map(this.gmap.nativeElement);
    this.map.setZoom(16);
    this.map.setCenter(new google.maps.LatLng(this.dataCliente.Latitud, this.dataCliente.Longitud));
    this.marker.setMap(this.map);
   }

}
